import { connect } from 'react-redux';

import { currentAppEntity } from 'app/developer-v3/selectors';
import * as CliApp from 'app/entities/CliApp';

import ZapPrefillGenerator from './ZapPrefillGenerator';

function mapStateToProps(state: any) {
  const app = currentAppEntity(state);
  const serviceSlug = CliApp.selectors.slug(app) || '';
  return { serviceSlug };
}

export default connect(mapStateToProps)(ZapPrefillGenerator);
